import {api} from '../utils'

export default {
    // Organizations — /api/v1/admin/organizations
    listOrganizations: params => api.get('/admin/organizations', {params}),
    getOrganization: id => api.get(`/admin/organizations/${id}`),
    createOrganization: data => api.post('/admin/organizations', data),
    updateOrganization: (id, data) => api.put(`/admin/organizations/${id}`, data),
    uploadOrganizationLogo: (id, formData) =>
        api.post(`/admin/organizations/${id}/logo`, formData, {headers: {'Content-Type': 'multipart/form-data'}}),

    // HHAeXchange EVV credentials — /api/v1/admin/organizations/:orgId/hhax-credentials
    // Write-only: the secret is never returned. Current state is read from the
    // organization's own `hhax.credential` block. Needs evv.settings.manage,
    // which only Careviah platform admins hold.
    setHhaxCredentials: (orgId, data) => api.put(`/admin/organizations/${orgId}/hhax-credentials`, data),
    // Re-checks the stored credential against HHAeXchange without re-entering the secret.
    verifyHhaxCredentials: orgId => api.post(`/admin/organizations/${orgId}/hhax-credentials/verify`),

    // Organization Branches — /api/v1/admin/organizations/:orgId/branches
    listBranches: (orgId, params) => api.get(`/admin/organizations/${orgId}/branches`, {params}),
    getBranch: (orgId, branchId) => api.get(`/admin/organizations/${orgId}/branches/${branchId}`),
    createBranch: (orgId, data) => api.post(`/admin/organizations/${orgId}/branches`, data),
    updateBranch: (orgId, branchId, data) => api.put(`/admin/organizations/${orgId}/branches/${branchId}`, data),
    deleteBranch: (orgId, branchId) => api.delete(`/admin/organizations/${orgId}/branches/${branchId}`),

    // Organization Users — /api/v1/admin/organizations/:orgId/users
    listOrgUsers: (orgId, params) => api.get(`/admin/organizations/${orgId}/users`, {params}),
    createOrgUser: (orgId, data) => api.post(`/admin/organizations/${orgId}/users`, data),
    getOrgUserRoles: (orgId, userId) => api.get(`/admin/organizations/${orgId}/users/${userId}/roles`),
    assignOrgUserRole: (orgId, userId, data) => api.post(`/admin/organizations/${orgId}/users/${userId}/roles`, data),

    // Roles that can be given to a user of this organization. Distinct from
    // GET /roles, which answers for the caller's own organization — Careviah's,
    // for a platform admin.
    listOrgRoles: orgId => api.get(`/admin/organizations/${orgId}/roles`),
    resendOrgUserInvitation: (orgId, userId) => api.post(`/admin/organizations/${orgId}/users/${userId}/resend-invitation`),

    // Organization Payers — /api/v1/admin/organizations/:orgId/payers
    listPayers: orgId => api.get(`/admin/organizations/${orgId}/payers`),
    createPayer: (orgId, data) => api.post(`/admin/organizations/${orgId}/payers`, data),
    getPayer: (orgId, payerId) => api.get(`/admin/organizations/${orgId}/payers/${payerId}`),
    updatePayer: (orgId, payerId, data) => api.put(`/admin/organizations/${orgId}/payers/${payerId}`, data),
    deletePayer: (orgId, payerId) => api.delete(`/admin/organizations/${orgId}/payers/${payerId}`),

    // Branch Payers — /api/v1/admin/branch-payers
    // NOTE: as of this writing these admin routes are defined in the backend handler
    // (branch_payer.Handler.RegisterAdminRoutes) but not yet mounted in cmd/server/main.go
    // (only RegisterProviderRoutes is wired, under /api/v1/branch-payers). These calls will
    // 404 until the backend wires up RegisterAdminRoutes under /admin.
    listBranchPayers: params => api.get('/admin/branch-payers', {params}),
    createBranchPayer: data => api.post('/admin/branch-payers', data),
    getBranchPayer: id => api.get(`/admin/branch-payers/${id}`),
    deleteBranchPayer: id => api.delete(`/admin/branch-payers/${id}`),

    // Service Catalog — /api/v1/admin/services/service-catalog
    listServiceCatalog: params => api.get('/admin/services/service-catalog', {params}),
    createServiceCatalogItem: data => api.post('/admin/services/service-catalog', data),

    // Branch Services (provider-level assignment) — /api/v1/admin/services/providers/:providerId
    listBranchServices: (providerId, params) => api.get(`/admin/services/providers/${providerId}/branch-services`, {params}),
    assignServicesToProvider: (providerId, data) => api.post(`/admin/services/providers/${providerId}/services`, data),
}
